import React, { useCallback } from "react";

import clsx from "clsx";
import Link from "next/link";

import { formatCurrency } from "@/utils/currency";

import styles from "./CartAddedNotification.module.scss";

interface CartAddedNotificationProps {
  freeShippingPrice: number;
  onLinkClick?: () => void;
}

// カート追加時に発生する通知
export function CartAddedNotification({
  freeShippingPrice,
  onLinkClick,
}: CartAddedNotificationProps) {
  const goToCartPage = useCallback(() => {
    onLinkClick?.();
  }, [onLinkClick]);

  return (
    <div className={clsx(styles.oneClickDone)}>
      <div className="text__left">
        <p className="text__s text__white">&#10003; カートに追加されました</p>
        {freeShippingPrice > 0 && (
          <p className="text__s text__yellow text__bold mg__top__xs">
            あと{formatCurrency(freeShippingPrice)}で送料無料
          </p>
        )}
      </div>
      <button type="button" className="text__center">
        <Link href="/cart" onClick={goToCartPage}>
          <span className={clsx(styles.oneClickDoneLink, "text__m text__bold text__white")}>
            カートを確認
          </span>
        </Link>
      </button>
    </div>
  );
}
